import { Button, ButtonGroup, Grid, withStyles, Theme } from '@material-ui/core'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { UpdateStatus, UpdateStatusWithForm } from '../../actions/types'
import UpdateStatusFormProps from '../../containers/Apartments/AdminView/updateStatusForm'
import Dialog from '../../containers/Dialog'
import {
  isApartmentMarketingDisabled,
  isApartmentCancelledDisabled
} from '../../libs/statuses'
import { MuiClasses } from '../../types'
import { ApartmentStatus, Status } from '../../types/apartments'
import { Message } from '../Messages'

const styles = ({ breakpoints, spacing }: Theme) => ({
  primaryBtn: {
    backgroundColor: '#4f9b44',
    '&:hover': {
      backgroundColor: '#3f7c36'
    }
  }
})
interface UpdateStatusButtonProps {
  classes: MuiClasses
  currentStatus: Status
  updateStatus: UpdateStatus
  t: TFunction
  updateStatusWithForm: UpdateStatusWithForm
  address: string | undefined
}

const UpdateStatusButtons: FC<UpdateStatusButtonProps> = ({
  classes,
  currentStatus,
  updateStatus,
  updateStatusWithForm,
  t,
  address
}) => {
  const commonButtonProps = {
    size: 'small' as const
  }

  const rentContractTitle =
    currentStatus === 'rentContractWanted'
      ? t('adminApartments.actions.updateApplicationId')
      : t('adminApartments.changeStatus.toRentContractWanted')

  return (
    <Grid container>
      <ButtonGroup
        variant='contained'
        color='primary'
        aria-label='contained primary button group'
      >
        <Button
          className={classes.primaryBtn}
          {...commonButtonProps}
          disabled={isApartmentMarketingDisabled(currentStatus)}
          onClick={() => updateStatus(ApartmentStatus.marketing)}
        >
          {t('adminApartments.changeStatus.toMarketing')}
        </Button>
        <Dialog
          dialogId='UpdateApartmentStatus'
          title={rentContractTitle}
          buttonLabel={rentContractTitle}
          Content={
            <UpdateStatusFormProps
              t={t}
              updateStatusWithForm={updateStatusWithForm}
              initialValues={{
                status: ApartmentStatus.rentContractWanted
              }}
            />
          }
        />
      </ButtonGroup>
      <Grid item style={{ marginLeft: 'auto' }}>
        <Dialog
          dialogId='UpdateStatusToCancelled'
          disabled={isApartmentCancelledDisabled(currentStatus)}
          color='secondary'
          title={t('apartments.cancel.label')}
          buttonLabel={t('adminApartments.changeStatus.toCancelled')}
          confirmDialogSubmitAction={() =>
            updateStatus(ApartmentStatus.cancelled)
          }
          Content={
            <Message
              message={t('apartments.cancel.confirmMessage', {
                address: address || ''
              })}
            />
          }
        />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(UpdateStatusButtons)
